import React from "react";
import "../Styles/BusinessSetupHeader.css";
import logo from "../assests/images/Business_set_up_logo.png";

export default function BusinessSetupHeader({name}) {
  return (
    <div className="business-header">
      <img src={logo} alt="logo" className="business-header-logo" />

      <div className="business-header-title">
         {name}
        <div className="business-header-underline"></div>
      </div>
    </div>
  );
}
